/*
 * cart-extras.js — interactions du tiroir panier Relia
 *  - upsell : case à cocher qui ajoute / retire un produit
 *  - produits associés : bouton « Ajouter »
 * Après chaque action, on demande au thème les sections fraîches et on
 * laisse <cart-drawer>.renderContents() rafraîchir tout le tiroir.
 */
(function () {
  const SECTIONS = 'cart-drawer,cart-icon-bubble';

  // Déclarés tout en haut : injectRecentReco / readRecentIds (fonctions hoistées)
  // sont appelées par refreshUi() dès le chargement, AVANT leur position dans le
  // fichier. Déclarés plus bas, ces accès tomberaient dans la zone morte
  // temporelle du `let`/`const` (ReferenceError) et interromplaient l'IIFE — les
  // écouteurs resize / MutationObserver ne seraient alors jamais attachés.
  let recentPending = false;
  const RECENT_KEY = 'relia:recently-viewed';
  const RECENT_DAYS = 30;

  function config(type = 'json') {
    if (typeof fetchConfig === 'function') return fetchConfig(type);
    return {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/' + type },
    };
  }

  function refresh(state) {
    const drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      drawer.renderContents(state);
    }
    // renderContents ne gère pas le passage plein -> vide : on bascule
    // nous-mêmes les classes is-empty (sinon tiroir blanc, cf. état vide)
    if (state && typeof state.item_count === 'number') {
      const isEmpty = state.item_count === 0;
      if (drawer) drawer.classList.toggle('is-empty', isEmpty);
      const items = document.querySelector('cart-drawer-items');
      if (items) items.classList.toggle('is-empty', isEmpty);
    }
    // PUB_SUB_EVENTS est un `const` global (constants.js) : il n'existe PAS en
    // propriété de window, on le teste donc via typeof (sinon jamais publié).
    if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-extras', cartData: state });
    }
  }

  function changeQuantity(variantId, quantity) {
    const body = JSON.stringify({
      id: String(variantId),
      quantity: quantity,
      sections: SECTIONS,
      sections_url: window.location.pathname,
    });
    return fetch(window.routes.cart_change_url, Object.assign(config(), { body }))
      .then((r) => r.json())
      .then(refresh);
  }

  function addItem(variantId) {
    const body = JSON.stringify({
      items: [{ id: Number(variantId), quantity: 1 }],
      sections: SECTIONS,
      sections_url: window.location.pathname,
    });
    return fetch(window.routes.cart_add_url, Object.assign(config(), { body }))
      .then((r) => r.json())
      .then((data) => {
        if (data && data.status) return; // erreur Shopify (ex : épuisé)
        refresh(data);
      });
  }

  // Upsell : la case à cocher ajoute (coché) ou retire (décoché) le produit
  document.addEventListener('change', function (event) {
    const checkbox = event.target.closest('.cart-upsell__checkbox');
    if (!checkbox) return;
    const variantId = checkbox.dataset.variantId;
    if (!variantId) return;
    checkbox.disabled = true;
    const action = checkbox.checked ? addItem(variantId) : changeQuantity(variantId, 0);
    action.catch((e) => {
      console.error('[cart-extras] upsell', e);
      checkbox.checked = !checkbox.checked;
    });
  });

  // Produits associés : défilement horizontal à la souris (drag-to-scroll),
  // comme une collection en vedette. Le scroll tactile reste natif.
  let drag = null;

  document.addEventListener('pointerdown', function (event) {
    if (event.pointerType !== 'mouse' || event.button !== 0) return;
    const list = event.target.closest('.cart-reco__list');
    if (!list) return;
    drag = { list: list, startX: event.clientX, startScroll: list.scrollLeft, moved: false };
  });

  document.addEventListener('pointermove', function (event) {
    if (!drag) return;
    const dx = event.clientX - drag.startX;
    if (!drag.moved && Math.abs(dx) > 5) {
      drag.moved = true;
      drag.list.classList.add('is-dragging');
    }
    if (drag.moved) drag.list.scrollLeft = drag.startScroll - dx;
  });

  document.addEventListener('pointerup', function () {
    if (!drag) return;
    drag.list.classList.remove('is-dragging');
    const finished = drag;
    setTimeout(function () {
      if (drag === finished) drag = null;
    });
  });

  // Si on a glissé, on annule le clic qui suit (lien produit ou bouton)
  document.addEventListener(
    'click',
    function (event) {
      if (drag && drag.moved && event.target.closest('.cart-reco__list')) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );

  // Message de la frise : la plus grande taille de police qui tient sur une
  // seule ligne (réajusté à chaque rendu du tiroir et au redimensionnement)
  function fitProgressMessage() {
    const msg = document.querySelector('.cart-progress__message');
    if (!msg) return;
    let size = 14;
    msg.style.fontSize = size + 'px';
    while (size > 9 && msg.scrollWidth > msg.clientWidth) {
      size -= 0.5;
      msg.style.fontSize = size + 'px';
    }
  }

  // Flèches des produits associés : grise celle de gauche/droite quand on est
  // au bout du défilement (rien à faire de ce côté).
  function updateRecoArrows() {
    const list = document.querySelector('.cart-reco__list');
    if (!list) return;
    const prev = document.querySelector('.cart-reco__arrow[data-dir="-1"]');
    const next = document.querySelector('.cart-reco__arrow[data-dir="1"]');
    const max = list.scrollWidth - list.clientWidth;
    if (prev) prev.disabled = list.scrollLeft <= 1;
    if (next) next.disabled = list.scrollLeft >= max - 1;
  }

  function refreshUi() {
    fitProgressMessage();
    injectRecentReco();
    updateRecoArrows();
  }

  const refreshSoon = (() => {
    let t;
    return function () {
      clearTimeout(t);
      t = setTimeout(refreshUi, 50);
    };
  })();

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', refreshUi);
  } else {
    refreshUi();
  }
  window.addEventListener('resize', refreshSoon);

  // On ne surveille QUE le tiroir. Tout ce que refreshUi() retouche (frise,
  // produits associés, upsell, code promo) vit à l'intérieur de <cart-drawer>,
  // et renderContents() ne remplace que le contenu de #CartDrawer : l'élément
  // <cart-drawer> lui-même reste en place, l'observateur tient donc.
  // Surveiller document.documentElement réveillait refreshUi à CHAQUE insertion
  // de nœud faite par n'importe quelle app de la page (pop-up Shopify Forms,
  // widget d'avis, carrousel vidéo, enregistreur de session). Chaque réveil
  // relit la mise en page (scrollWidth / clientWidth), du travail inutile qui
  // retarde la réponse aux clics — c'est ce que mesure l'INP.
  const drawerEl = document.querySelector('cart-drawer');
  if (drawerEl) {
    new MutationObserver(refreshSoon).observe(drawerEl, { childList: true, subtree: true });
  }

  // Clic sur une flèche : défile la liste d'environ une largeur visible
  document.addEventListener('click', function (event) {
    const arrow = event.target.closest('.cart-reco__arrow');
    if (!arrow || arrow.disabled) return;
    const list = document.querySelector('.cart-reco__list');
    if (!list) return;
    const dir = Number(arrow.dataset.dir) || 1;
    const step = Math.max(list.clientWidth * 0.8, 200);
    // assignation simple : animée par scroll-behavior:smooth (CSS) sur la liste
    list.scrollLeft += dir * step;
  });

  // Met à jour les flèches pendant le défilement (clic, drag ou tactile)
  document.addEventListener(
    'scroll',
    function (event) {
      const t = event.target;
      if (t && t.classList && t.classList.contains('cart-reco__list')) updateRecoArrows();
    },
    true
  );

  // Code de réduction : appliqué via l'API panier (champ "discount" de
  // /cart/update.js). Le total est recalculé et le code suit au paiement.
  function appliedCodes() {
    const box = document.querySelector('.cart-discount');
    if (!box || !box.dataset.appliedCodes) return [];
    return box.dataset.appliedCodes.split(',').filter(Boolean);
  }

  function updateDiscounts(codes) {
    const body = JSON.stringify({
      discount: codes.join(','),
      sections: SECTIONS,
      sections_url: window.location.pathname,
    });
    return fetch('/cart/update.js', Object.assign(config(), { body })).then((r) => r.json());
  }

  document.addEventListener('submit', function (event) {
    const form = event.target.closest('.cart-discount__form');
    if (!form) return;
    event.preventDefault();
    const input = form.querySelector('.cart-discount__input');
    const error = form.parentElement.querySelector('.cart-discount__error');
    const code = (input.value || '').trim();
    if (!code) return;
    error.hidden = true;
    form.classList.add('is-loading');
    const previous = appliedCodes();
    const codes = previous.slice();
    if (!codes.includes(code)) codes.push(code);

    updateDiscounts(codes)
      .then((state) => {
        const entry = (state.discount_codes || []).find(
          (d) => d.code.toLowerCase() === code.toLowerCase()
        );
        if (entry && entry.applicable) {
          refresh(state);
        } else {
          form.classList.remove('is-loading');
          error.hidden = false;
          input.select();
          // On retire le code refusé du panier
          if (!previous.includes(code)) updateDiscounts(previous);
        }
      })
      .catch((e) => {
        console.error('[cart-extras] discount', e);
        form.classList.remove('is-loading');
      });
  });

  document.addEventListener('click', function (event) {
    const button = event.target.closest('.cart-discount__remove');
    if (!button || button.disabled) return;
    button.disabled = true;
    const codes = appliedCodes().filter((c) => c !== button.dataset.code);
    updateDiscounts(codes)
      .then(refresh)
      .catch((e) => {
        console.error('[cart-extras] discount remove', e);
        button.disabled = false;
      });
  });

  // Produits associés : bouton « Ajouter »
  document.addEventListener('click', function (event) {
    const button = event.target.closest('.cart-reco__add');
    if (!button || button.disabled) return;
    const variantId = button.dataset.variantId;
    if (!variantId) return;
    button.disabled = true;
    button.classList.add('is-loading');
    addItem(variantId).catch((e) => {
      console.error('[cart-extras] reco', e);
      button.disabled = false;
      button.classList.remove('is-loading');
    });
  });

  // Bijoux « déjà repérés » en tête des produits associés
  // ------------------------------------------------------
  // Les best-sellers sont rendus côté serveur. Ici on injecte EN PREMIER les
  // bijoux que la visiteuse a consultés (mémorisés dans son navigateur, même
  // stockage que la section « Vu récemment »), récupérés via la Section
  // Rendering API pour garder exactement le même markup que les best-sellers.
  // Rejoué à chaque rendu du tiroir (la liste serveur est reconstruite).
  // RECENT_KEY / RECENT_DAYS sont déclarés en haut de l'IIFE (TDZ, voir plus haut).

  function readRecentIds() {
    let items;
    try {
      items = JSON.parse(localStorage.getItem(RECENT_KEY)) || [];
    } catch (e) {
      return [];
    }
    const cutoff = Date.now() - RECENT_DAYS * 86400000;
    return items
      .filter((item) => item && item.id && item.ts > cutoff)
      .map((item) => String(item.id));
  }

  // Un seul fetch à la fois (le tiroir peut se re-rendre plusieurs fois au
  // chargement ; sans ce verrou on lancerait des fetchs concurrents).
  // recentPending est déclaré en haut de l'IIFE (voir commentaire là-bas).
  function injectRecentReco() {
    const wrapper = document.querySelector('[data-cart-reco]');
    if (!wrapper) return;
    const list = wrapper.querySelector('.cart-reco__list');
    if (!list) return;
    // Idempotence : marqueur porté par les cartes injectées. renderContents
    // reconstruit la liste (best-sellers seuls, sans marqueur) → on rejoue.
    if (list.querySelector('.cart-reco__item--recent')) return;
    if (recentPending) return;

    const recentIds = readRecentIds().slice(0, 12);
    if (recentIds.length === 0) return;

    const searchUrl = wrapper.dataset.searchUrl || (window.routes && window.routes.search_url) || '/search';
    const query = recentIds.map((id) => 'id:' + id).join(' OR ');
    const url =
      searchUrl +
      '?section_id=cart-reco-recent&type=product&q=' +
      encodeURIComponent(query);

    recentPending = true;
    fetch(url)
      .then((response) => response.text())
      .then((text) => {
        // La liste peut avoir été reconstruite pendant le fetch (re-rendu du
        // tiroir au chargement) : on vise TOUJOURS la liste vivante à cet instant,
        // jamais une référence capturée qui pourrait être détachée du DOM.
        const liveWrapper = document.querySelector('[data-cart-reco]');
        const liveList = liveWrapper && liveWrapper.querySelector('.cart-reco__list');
        if (!liveList || liveList.querySelector('.cart-reco__item--recent')) return;

        const doc = new DOMParser().parseFromString(text, 'text/html');
        const holder = doc.querySelector('[data-cart-reco-recent]');
        if (!holder) return;
        let recentItems = Array.from(holder.querySelectorAll('.cart-reco__item'));
        if (recentItems.length === 0) return;

        // Ordre du plus récent au plus ancien (la recherche ne le garantit pas)
        recentItems.sort(
          (a, b) => recentIds.indexOf(a.dataset.productId) - recentIds.indexOf(b.dataset.productId)
        );
        recentItems.forEach((li) => li.classList.add('cart-reco__item--recent'));

        // Dédoublonnage : un bijou repéré ne doit pas réapparaître plus bas
        // dans les best-sellers (le repéré passe devant).
        const recentSet = new Set(recentItems.map((el) => el.dataset.productId));
        Array.from(liveList.children).forEach((li) => {
          if (recentSet.has(li.dataset.productId)) li.remove();
        });

        // Injection en tête, dans l'ordre
        const first = liveList.firstElementChild;
        recentItems.forEach((li) => liveList.insertBefore(li, first));

        // On borne à la limite (repérés prioritaires, best-sellers en secours)
        const limit = parseInt(liveWrapper.dataset.limit, 10) || 6;
        while (liveList.children.length > limit) liveList.lastElementChild.remove();

        liveWrapper.classList.remove('cart-reco--empty');
        liveList.scrollLeft = 0;
        if (typeof updateRecoArrows === 'function') updateRecoArrows();
      })
      .catch(() => {
        /* réseau indisponible : on garde les best-sellers seuls */
      })
      .finally(() => {
        recentPending = false;
      });
  }
})();
